import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import lightBulbUrl from '@repo/assets/icons/lightbulb.svg?url';
import { colorPalette } from '@repo/mui-config/color-palette';

export const ContactDataDisclaimer = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        border: `1px solid ${colorPalette.primary.main}`,
        backgroundColor: colorPalette.cloud.light,
        borderRadius: '10px',
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        marginTop: '16px',
      }}
    >
      <Box sx={{ width: '15px', height: '15px' }}>
        <Box
          component="img"
          src={lightBulbUrl}
          alt="lightbulb"
          sx={{ width: '100%', height: '100%' }}
        />
      </Box>
      <Typography fontSize={12} lineHeight={'14px'} color={colorPalette.primary.main}>
        {t('welcomePage.loanApplicationPossible.liberis.companyData.disclaimer')}
      </Typography>
    </Box>
  );
};
